import { gql } from '@apollo/client';

const schema = {
  assignment: {
    name: 'setCouponUser',
    serviceName: 'unitadmin',
    query: gql`
      mutation setCouponUser($coupon_id: String!, $user_category_id: String, $send_sms: [String]) {
        setCouponUser(coupon_id: $coupon_id, user_category_id: $user_category_id, send_sms: $send_sms) {
          messages
        }
      }
    `,
  },
};

export default schema;
